// ChoiceStateMessageSink.vue
//  Listen for 'choice-state' messages
<script lang="ts" setup>
    import { onMounted, onUnmounted, ref } from "vue"
    import { currentChoiceUserSessionGuid, timeout } from "../lib/ChoiceUtils"
    import { ChoiceLogoutMessageEventHandler } from "../lib/ChoiceMessageEventHandler"

    const emit = defineEmits<{
        (e: "message", event: MessageEvent<any>): void
    }>();

    const props = withDefaults(defineProps<{
            handleLogoutMessage?: boolean,
            channelName?: string, // Override normal channel name
            logoutExceptionFiles?: string|string[],
            currentPathOveride?: string
        }>(), {
            handleLogoutMessage: true,
            logoutExceptionFiles: "mainwindow.htm"
        });


    const channel = ref(new BroadcastChannel(props.channelName ?? "choice-state_" + currentChoiceUserSessionGuid()));

    onMounted(async () => { 
        channel.value.addEventListener("message", ListenForMessageEvent); 
    });

    onUnmounted(() =>{ 
        channel.value.removeEventListener("message", ListenForMessageEvent);
        channel.value.close();

    });

    function ListenForMessageEvent(event: MessageEvent<any>)
    {
        // Ignore messages from other origins
        if (event.origin !== location.origin)
            return;

        // HACK: 'debugger' cuases issues
        // While debugging, if someone adds a debugger between sink events for a message, it terminates the calls. 
        //  By delaying one second, we are allowing the messages to get handled and then we fire our event which 
        //  can now can use debugger statements safely.
        timeout(1).then(() => {

            // Emit the message
            emit("message", event);

            if (props.handleLogoutMessage)
            {
                // Is if this page is an exception for logout
                const logoutExceptions: string[] = [];
                if (typeof(props.logoutExceptionFiles) === typeof(""))
                {
                    logoutExceptions.push(props.logoutExceptionFiles as string);
                }
                else
                {
                    logoutExceptions.push(...props.logoutExceptionFiles);
                }

                const currentPath = (props.currentPathOveride ?? location.pathname).toLowerCase();
                if (logoutExceptions.find(item => currentPath.endsWith(item.toLowerCase())))
                    return;

                ChoiceLogoutMessageEventHandler(event);
            }
        });
    }
</script>
